import { Lock } from "lucide-react";
import type { ComplaintHistoryEvent } from "@/api/types";
import { formatDateTime } from "./constants";

const EVENT_LABEL: Record<string, string> = {
  created: "Створено",
  submitted: "Подано",
  assigned: "Призначено",
  auto_assigned: "Авто-призначено",
  needs_manual_assignment: "Потребує призначення",
  reassigned: "Перепризначено",
  routed_to_quality: "Скеровано в чергу SupportQuality",
  claimed: "Взято з черги",
  returned_to_queue: "Повернуто в чергу",
  rerouted: "Передано в чергу / відділ",
  in_progress: "Взято в роботу",
  initial_response_sent: "Надано первинну відповідь",
  marked_awaiting_client: "Очікує клієнта",
  resolution_proposed: "Запропоновано рішення",
  resolution_financial_approved: "Фінрішення погоджено",
  resolution_financial_rejected: "Фінрішення відхилено",
  resolution_proposal_cancelled: "Пропозицію скасовано",
  resolution_approval_revoked: "Погодження відкликано",
  resolution_applied: "Рішення застосовано",
  resolved: "Вирішено",
  closed: "Закрито",
  auto_closed: "Авто-закрито",
  rejected: "Відхилено",
  reopened: "Відкрито повторно",
  escalated: "Ескальовано",
  de_escalated: "Деескальовано",
  severity_changed: "Змінено важливість",
  sla_overridden: "Строки перевизначено",
  sla_initial_response_breached: "Прострочено першу відповідь",
  sla_resolution_breached: "Прострочено вирішення",
  attachment_added: "Додано вкладення",
  attachment_superseded: "Вкладення замінено",
  attachment_downloaded: "Завантажено вкладення",
  evidence_integrity_failed: "Помилка цілісності доказів",
  applied_evidence_retention_finalized: "Зафіксовано зберігання доказів",
  personal_data_redacted: "Персональні дані відредаговано",
  complaint_deleted: "Рекламацію видалено",
  follow_up_task_created: "Створено завдання",
  // D-133 — supplier outreach
  supplier_email_sent: "Надіслано постачальнику",
  supplier_email_failed: "Помилка надсилання постачальнику",
  supplier_response: "Відповідь постачальника отримана",
};

export function EventTimeline({ events }: { events: ComplaintHistoryEvent[] }) {
  if (events.length === 0) {
    return <p className="text-sm text-muted-foreground">Подій ще немає.</p>;
  }
  return (
    <ol className="relative space-y-3 border-l border-border pl-4">
      {events.map((e) => (
        <li key={e.id} className="relative">
          <span className="absolute -left-[21px] top-1 h-2.5 w-2.5 rounded-full border-2 border-background bg-primary/60" aria-hidden />
          <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
            <span className="text-sm font-medium">{EVENT_LABEL[e.eventType] ?? e.eventType}</span>
            {e.fromState && e.toState && e.fromState !== e.toState && (
              <span className="text-[12px] text-muted-foreground">
                {e.fromState} → {e.toState}
              </span>
            )}
            {e.personalDataRedacted && (
              <span className="inline-flex items-center gap-1 text-[12px] text-muted-foreground">
                <Lock className="h-3 w-3" aria-hidden /> редаговано
              </span>
            )}
          </div>
          <div className="text-[12px] text-muted-foreground">
            {formatDateTime(e.eventAt)}
            {e.actorUser?.name ? ` · ${e.actorUser.name}` : ""}
          </div>
          {e.notes && <p className="mt-0.5 text-[13px] text-foreground/80">{e.notes}</p>}
        </li>
      ))}
    </ol>
  );
}
